// removed by extract-text-webpack-plugin
module.exports = {"socialIcon":"socialIcon__QO1Ts"};


//////////////////
// WEBPACK FOOTER
// ./components/spareparts/social/style.less
// module id = T1Xn
// module chunks = 75